<template>
  <div class="home">
    <swiper :options="swiperOption" ref="mySwiper" v-if="banners.length!=0">
      <!-- <swiper-slide v-for="(item,index) in banners" :key="index">
        <img :src="item.image" :alt="index" />
      </swiper-slide> -->
      <swiper-slide>
        <img src="../assets/images/banner2.png"/>
      </swiper-slide>
      <swiper-slide>
        <img src="../assets/images/banner3.png"/>
      </swiper-slide>
      <swiper-slide>
        <img src="../assets/images/banner1.png"/>
      </swiper-slide>


      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>

    <section class="no-padding-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h4 class="text-primary">汉邦微云</h4>
            <h2>为您提供</h2>
            <div class="industris-space-30"></div>
            <!-- 
						<div class="services-block-left">
							<div class="services-slider-img-left">
								<img src="../assets/images/services-solution.png" alt="">
							</div>
            </div>-->

            <div class="services-slider">
              <div class="services-item col-md-4 col-xs-12">
                <div class="services-box">
                  <div class="services-icon">
                    <img src="../assets/images/services-icon-1.png" alt />
                  </div>
                  <div class="services-content">
                    <h3>
                      <router-link :to="{name: 'services_pms'}" class="active_item">PMS软件</router-link>
                    </h3>
                    <p>采用中央管理系统，随时随地查阅酒店报表，掌握会员、预定、消费、入住情况，可提供与ERP、OA、财务软件、公安接口、电子门锁系统、会员卡等多种接口对接。</p>
                    <div class="industris-space-10"></div>
                    <a class="view-detail">
                      <!-- <router-link :to="{name: 'services_pms'}" class="active_item">了解更多</router-link> -->
                      <i class="icon ion-md-add-circle-outline"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="services-item col-md-4 col-xs-12">
                <div class="services-box">
                  <div class="services-icon">
                    <img src="../assets/images/services-icon-2.png" alt />
                  </div>
                  <div class="services-content">
                    <h3>
                      <router-link :to="{name: 'services_pos'}" class="active_item">移动应用</router-link>
                    </h3>
                    <p>酒店微信公众平台（微官网），吸引粉丝、培育会员、转化OTA客，全自助、多功能、一站式服务，包含在线订房点餐、在线查看经营收入、房态时实况等，协助经营者更好的管理酒店。</p>
                    <div class="industris-space-10"></div>
                    <a class="view-detail">
                      <!-- <router-link :to="{name: 'services_pos'}" class="active_item">了解更多</router-link> -->
                      <i class="icon ion-md-add-circle-outline"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="services-item col-md-4 col-xs-12">
                <div class="services-box">
                  <div class="services-icon">
                    <img src="../assets/images/services-icon-3.png" alt />
                  </div>
                  <div class="services-content">
                    <h3>
                      <router-link :to="{name: 'services_zzj'}" class="active_item">自助设备</router-link>
                    </h3>
                    <p>客人使用酒店自助服务机可独立完成登记、续住和结账等手续，方便快捷，入住可以做到来无影去无踪。保护客人隐私，减少总台服务人员，降低酒店经营成本，提高酒店竞争优势。</p>
                    <div class="industris-space-10"></div>
                    <a class="view-detail">
                      <!-- <router-link :to="{name: 'services_sangna'}" class="active_item">了解更多</router-link> -->
                      <i class="icon ion-md-add-circle-outline"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="industris-space-90"></div>
    </section>

    <section class="bg-primary no-padding">
      <div class>
        <div class="flex-row">
          <div
            class="video-section-left"
            :style="{backgroundImage:`url(${require('../assets/images/home-right-img-1.jpg')})`}"
          ></div>
          <div class="video-section-right">
            <div class="block-right">
              <h4>酒店信息产业服务专家</h4>
              <h2>
                <b>汉邦微云</b>
              </h2>
              <p>一家专业从事酒店信息产业服务与开发的高新企业，有着十几年行业经验和专业服务，一直在努力研究、探索适合中国酒店业信息技术的应用模式与解决方案，本着简洁、实用、易操作、科学性、严密性的原则，成为酒店行业管理的好帮手。</p>

              <p>
                <router-link :to="{name: 'about'}" class="text-white">了解更多</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="partner-slider image-carousel text-center" data-show="5" data-arrow="false">
              <template v-for="(item,index) in projects">
                <div v-if="index < 6" :key="index">
                  <div class="partner-item text-center clearfix col-md-2">
                    <div class="inner">
                      <div class="thumb">
                        <img :src="item.image" :alt="item.name" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <!-- <hr> -->
        <div class="industris-space"></div>
      </div>

      <div class="container">
        <div class="row flex-row">
          <div class="col-md-6 align-self-center">
            <h3>合作客户</h3>
            <p>汉邦微云已为近万家酒店提供服务，我们为客户提供免费咨询、演示的售前服务，系统安装培训，对店方员工进行软件培训与考核，免费网络售后，终身维护，一站式解决酒店软件管理方案。</p>

            <p>
              <!-- <router-link :to="{name: 'project'}">查看更多</router-link> -->
            </p>
          </div>
          <div class="col-md-6">
            <img src="../assets/images/home-right-img-2.jpg" alt="home image" />
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="bg-light padding-bottom-medium">
      <div class="container">
        <div class="row flex-row">
          <div class="col-md-6">
            <h2 class="no-margin-bottom">邦威动态</h2>
          </div>
          <div class="col-md-6 text-right align-self-end">
            <a class="industris-lineheight">
              <router-link :to="{name: 'news'}" class="active_item">查看更多</router-link>
              <i class="icon ion-md-add-circle-outline"></i>
            </a>
          </div>
        </div>
        <div class="industris-space-50"></div>

        <div class="row">
          <template v-for="(item,index) in news">
            <div class="col-md-4 col-sm-6 col-xs-12" v-if="index < 3" :key="index">
              <article class="post-box post type-post entry">
                <div class="entry-media">
                  <router-link
                    class="text-white"
                    :to="{ path: '/news_list/news', query: {id: item.id} }"
                  >
                    <img :src="item.image" :alt="item.title" />
                  </router-link>
                </div>
                <div class="inner-post">
                  <header class="entry-header">
                    <div class="entry-meta">
                      <span class="posted-on">
                        <span class="entry-date published">{{dateFormat(item.time)}}</span>
                      </span>
                    </div>
                    <h3 class="entry-title">
                      <router-link
                        rel="bookmark"
                        :to="{ path: '/news_list/news', query: {id: item.id} }"
                      >{{item.title}}</router-link>
                    </h3>
                  </header>

                  <div class="entry-summary">
                    <p>{{item.desc}}</p>
                  </div>
                </div>
              </article>
            </div>
          </template>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import $ from "jquery";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "home",
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        speed: 2500,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      banners: [],
      projects: [],
      news: [],
    };
  },
  created() {
    let that = this;
    //数据请求
    this.$axios
      .get("/static/data.json")
      .then(function (response) {
        console.log(response);
        that.banners = response.data.data.banners;
        that.projects = response.data.data.projects;
        that.news = response.data.data.news;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  computed: {
    // swiper(){
    // 	return this.$refs.mySwiper.swiper
    // }
  },
  mounted() {
    //this.swiper.slideTo(5,1000,false)
  },
  methods: {
    dateFormat: function (time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    },
  },
};
</script>

<style>
.swiper-container img {
  width: 100%;
  height: 100%;
  margin: 0;
}
.partner-item {
  vertical-align: middle;
}
.partner-item img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue